/**
 * 监测数据
 * 最新cimiss数据
 */
import request from "@/utils/request";
const list = (areaCode: string, staLevels: string = "") => {
  const params: any = {
    elements:
      "station_name,station_levl,lat,lon,tem,pre_1h,pre_3h,pre_6h,pre_12h,pre_24h,datetime",
    refreshPrePeriod: 24,
  };
  if (areaCode !== "611000") {
    params.adminCodes = areaCode;
  }
  if (staLevels && staLevels !== "") {
    params.staLevels = staLevels;
  }
  return request.get("/cw/surface_data/list/surf_hour_data", params);
};

// 小时实况/历史
const hourHisData = (type: string, typeValue: any, timeRange: any) => {
  let params: any = {};

  if (type === "staIds") {
    params = {
      staIds: typeValue,
      elements:
        "admin_code_chn,station_name,station_id_c,lat,lon,pre_1h,tem,tem_max,tem_min,win_s_avg_2mi,win_d_avg_2mi,win_s_max,win_d_s_max,win_s_inst_max,win_d_inst_max,datetime,rhu,vis,prs",
    };
  } else if (type === "adminCodes") {
    params = {
      adminCodes: typeValue,
      // adminCodes: config.defaultStationObj.adminCode,
      elements:
        "admin_code_chn,station_name,station_id_c,lat,lon,pre_1h,tem,tem_max,tem_min,win_s_avg_2mi,win_d_avg_2mi,win_s_max,win_d_s_max,win_s_inst_max,win_d_inst_max,datetime,prs",
    };
  }
  if (timeRange) {
    params.timeRange = timeRange;
  }

  // signUtils(params)
  // return request.get('/cwSurface/surface_data/list/surf_hour_data', params)
  return request
    .get("/cw/surface_data/list/surf_hour_data", params)
    .then((data) => {
      if (data.length > 0) {
        return data;
      }
      return [];
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
};

//经纬度临近站点
const nearestStation = (
  areaCode: string = "610100",
  lng: number,
  lat: number
) => {
  const params: any = {
    areaCode: areaCode,
    lng,
    lat,
  };

  return request.get("/cw/nearest_station/one", params);
};

export default { list, nearestStation, hourHisData };
